import React from 'react';

const VisibilityToggle = ({ checked, onChange, loading }) => (
  <div className="flex items-center gap-3">
    <span className={`text-sm font-medium ${checked ? 'text-green-500' : 'text-gray-400'}`}>{checked ? 'Visible' : 'Hidden'}</span>
    <label className="relative inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        className="sr-only peer"
        checked={checked}
        onChange={onChange}
        disabled={loading}
      />
      <div className={`w-11 h-6 rounded-full transition-colors duration-200
        ${checked ? 'bg-green-500' : 'bg-gray-300'}
        peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-500
        after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all
        ${checked ? 'after:translate-x-5' : 'after:translate-x-0'}
      `} style={{ position: 'relative' }}></div>
      {loading && (
        <span className="absolute right-[-1.5rem] text-xs text-gray-400 animate-spin">⏳</span>
      )}
    </label>
  </div>
);

export default VisibilityToggle; 